import { Base } from '../base-component';
import './glossary-build.component.scss';

import * as $ from 'jquery';
import * as _ from 'lodash';

declare var jsonData;

export class GlossaryBuild extends Base {

	json: any;
	inputSearch: any;
	alphabetContainer: any;
	alphabetContainerMobile: any;
	contentContainer: any;
	contentContainerEmpty: any;
	contentContainerEmptyWording: any;
	buttons: any;

	constructor(element: Element) {

		super(element);

	}

	init() {

		this.inputSearch = this.element.querySelector('.js-search-bar');
		this.alphabetContainer = this.element.querySelector('.js-alphabet-block');
		this.alphabetContainerMobile = this.element.querySelector('.js-alphabet-block-mobile');
		this.contentContainer = this.element.querySelector('.js-glossary-content');
		this.contentContainerEmpty = this.element.querySelector('.js-glossary-content-empty');
		this.contentContainerEmptyWording = this.element.querySelector('.js-glossary-content-empty-wording');

		if (jsonData) {

			this.json = jsonData;
			this.buildLayout(this.json);

		}

	}

	bindEvents() {

		this.inputSearch.addEventListener('keydown', (evt) => {

			let value: any = this.inputSearch.value;
			this.buildLayout(this.json, value);

		})

		this.inputSearch.addEventListener('keyup', (evt) => {

			let value: any = this.inputSearch.value;
			this.buildLayout(this.json, value);

		})

		this.inputSearch.addEventListener('keypress', (evt) => {

			let value: any = this.inputSearch.value;
			this.buildLayout(this.json, value);

		})

		window.addEventListener('scroll', (event) => {

			let windowOffset = window.pageYOffset;
			let alphabetAnchors = Array.from(this.element.querySelectorAll('.js-alphabet-anchor'));
			alphabetAnchors.map((anchor: any) => {

				let getAttributeLetter = anchor.getAttribute('data-letter');
				let letterOffset = anchor.offsetTop;
				let letterHeight = anchor.clientHeight;
				let spaceOffset = letterOffset - windowOffset;
				let spaceHeight = (letterOffset + letterHeight) - windowOffset;

				let getButton = this.element.querySelector('a.js-alphabet-button[data-letter=' + getAttributeLetter + ']');
				let getButtonMobile = this.element.querySelector('a.js-alphabet-button-mobile[data-letter=' + getAttributeLetter + ']');

				if (spaceOffset < 20 && spaceHeight > 0) {
					getButton.classList.add('glossary-build__sticky--inner__jump--block__button--active');
					getButtonMobile.classList.add('glossary-build__sticky--inner__jump--block__button--active');
				} else {
					getButton.classList.remove('glossary-build__sticky--inner__jump--block__button--active');
					getButtonMobile.classList.remove('glossary-build__sticky--inner__jump--block__button--active');
				}

			})

		});

	}

	buildLayout(array = [], value = '') {

		let input = value.toLowerCase();
		let arrayNew = [];
		let arrayOld = this.json;
		let empty = true;

		arrayOld.forEach(letter => {

			let letterObject: any = {};
			let letterArray = [];
			let letterItems = letter.items;
			let letterName = letter.name;

			letterItems.forEach(item => {
				var itemName = item.name.toLowerCase();
				if (itemName.includes(input)) {
					letterArray.push(item);
					empty = false;
				}
			});

			letterObject.name = letterName;
			letterObject.items = letterArray;
			arrayNew.push(letterObject);

		});

		if (empty) {
			this.contentContainerEmptyWording.innerHTML = value;
			this.contentContainerEmpty.classList.remove('d-none');
		} else {
			this.contentContainerEmpty.classList.add('d-none');
		}

		if (value) {

			this.buildContent(arrayNew, value);
			this.buildAlphabets(arrayNew);

		} else {

			this.buildContent(arrayOld, value);
			this.buildAlphabets(arrayOld);

		}

	}

	buildContent(array = [], value = '') {

		this.contentContainer.innerHTML = '';

		let output = ``;

		array.forEach(letter => {

			if (letter.items.length > 0) {

				output += `<div class="glossary-build__letter js-alphabet-anchor" data-letter="${letter.name}">`;

				output += `<div class="glossary-build__title title--number">${letter.name}</div>`;

				letter.items.forEach(item => {

					if(value.length > 0) {

						let name = item.name;
						let lowercaseName = name.toLowerCase();
						let lowercaseValue = value.toLowerCase();
						let starting = lowercaseName.indexOf(lowercaseValue);
						let ending = starting + lowercaseValue.length;
						
						let getOrigString = `<span class="glossary-build__highlight">` + name.substring(starting, ending) + `</span>`;
						let getOrigStringBefore = name.substring(0, starting);
						let getOrigStringAfter = name.substring(ending, name.length);
						let newString = getOrigStringBefore + getOrigString + getOrigStringAfter;

						output += `<div class="title title title--module-sub-title">${newString}</div>`;

					}else{

						output += `<div class="title title title--module-sub-title">${item.name}</div>`;

					}

					output += `<div class="glossary-build__description">${item.description}</div>`;
					output += `<div class="glossary-build__spacer"></div>`;

				});

				output += `</div>`;

			}

		});

		let docFragment = document.createDocumentFragment();
		docFragment.appendChild(document.createRange().createContextualFragment(output));
		this.contentContainer.appendChild(docFragment);

	}

	buildAlphabets(array = []) {

		let output = ``;
		let index = 0;
		this.alphabetContainer.innerHTML = '';
		this.alphabetContainerMobile.innerHTML = '';
		let alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
		alphabet.forEach(letter => {

			let enablement = false;

			array.forEach(item => {

				if (item.name === letter) {

					if (item.items.length > 0) {

						enablement = true;

					}

				}

			});

			var btnLetter = document.createElement('a');
			var btnLetterMobile = document.createElement('a');

			btnLetter.innerText = letter;
			btnLetterMobile.innerText = letter;

			btnLetter.setAttribute('href', 'javascript:void(0)');
			btnLetterMobile.setAttribute('href', 'javascript:void(0)');
			btnLetter.setAttribute('data-letter', letter);
			btnLetterMobile.setAttribute('data-letter', letter);

			btnLetter.classList.add('glossary-build__sticky--inner__jump--block__button');
			btnLetterMobile.classList.add('glossary-build__sticky--inner__jump--block__button');
			btnLetter.classList.add('js-alphabet-button');
			btnLetterMobile.classList.add('js-alphabet-button-mobile');

			if (enablement) {

				index++;

				if (index === 1) {

					btnLetter.classList.add('glossary-build__sticky--inner__jump--block__button--active');
					btnLetterMobile.classList.add('glossary-build__sticky--inner__jump--block__button--active');

				}

				btnLetter.onclick = (event) => {
					let element = undefined;
					if (event.currentTarget) {
						element = event.currentTarget;
					} else {
						element = event.target;
					}
					let getLetter: any = element.getAttribute('data-letter');
					let getAnchor: any = this.element.querySelector('div.js-alphabet-anchor[data-letter=' + getLetter + ']');
					$('html, body').animate({
						scrollTop: getAnchor.offsetTop
					}, 500);
				}

				btnLetterMobile.onclick = (event) => {
					let element = undefined;
					if (event.currentTarget) {
						element = event.currentTarget;
					} else {
						element = event.target;
					}
					let getLetter: any = element.getAttribute('data-letter');
					let getAnchor: any = this.element.querySelector('div.js-alphabet-anchor[data-letter=' + getLetter + ']');
					$('html, body').animate({
						scrollTop: getAnchor.offsetTop
					}, 500);
				}

			} else {

				btnLetter.classList.add('glossary-build__sticky--inner__jump--block__button--inactive');
				btnLetterMobile.classList.add('glossary-build__sticky--inner__jump--block__button--inactive');

			}

			this.alphabetContainer.appendChild(btnLetter);
			this.alphabetContainerMobile.appendChild(btnLetterMobile);

		});

		var btnLBackToTop = document.createElement('a');
		btnLBackToTop.innerText = "BACK TO TOP";
		btnLBackToTop.setAttribute('href', 'javascript:void(0)');
		btnLBackToTop.classList.add('glossary-build__sticky--inner__jump--block__button');
		btnLBackToTop.classList.add('glossary-build__back-top');

		btnLBackToTop.onclick = (event) => {
			$('html, body').animate({
				scrollTop: 0
			}, 500);
		}
		this.alphabetContainer.appendChild(btnLBackToTop);

	}

	replaceString(str, start, end, replace) {
		if (start < 0 || start > str.length) {
			throw new RangeError(`start index ${start} is out of the range 0~${str.length}`);
		}
		if (end > str.length || end < start) {
			throw new RangeError(`end index ${end} is out of the range ${start}~${str.length}`);
		}
		return str.substring(0, start) + replace + str.substring(end);
	}

}


// WEBPACK FOOTER //
// ./components/glossary-build/glossary-build.component.ts